import $ from 'jquery';

$(document).ready(function () {
    const mobileButtonRefresh = () => {
        const has = $('#mobile-menu').hasClass('showing');
        $('#toggle-menu').html(has ? '<i class="fa-solid fa-xmark"></i>' : '<i class="fas fa-bars"></i>');
    };

    $(this).on('click', function (e) {
        if ($(e.target).closest('#toggle-menu').length) {
            $('#mobile-menu').toggleClass('showing')
            mobileButtonRefresh();
            return;
        }

        if ($(e.target).closest('#mobile-menu').length) {
            return;
        }

        $('#mobile-menu').removeClass('showing');

        if (!$('#toggle-menu').find('.fas.fa-bars').length > 0){
            mobileButtonRefresh();
        }
    })
})
